export interface StockItemSplit {
  id: string;
  stockNo: string;
  splitQty: number;
  orderNo: string;
  customerKey: string;
  customerName: string;
  despatchedQuantity: number;
  despatchNote: number;
  despatchDate: Date;
  invoicePrice: number;
  invoiceNumber: number;
  invoiceDate: Date;
}
